import { ChartExportFilter } from '@/components/charts/types';
import { formatTimestampForFilename } from '@/lib/utils';

const NON_ALPHANUMERIC_RUN = /[^a-z0-9]+/gu;
const LEADING_TRAILING_UNDERSCORES = /^_+|_+$/gu;

export const slugifyForFilename = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replace(NON_ALPHANUMERIC_RUN, '_')
    .replace(LEADING_TRAILING_UNDERSCORES, '');

const buildFilterSegment = (
  exportFilters?: Array<ChartExportFilter>
): string => {
  if (!exportFilters || exportFilters.length === 0) return '';
  const active = exportFilters.filter((filter) => filter.active);
  if (active.length === exportFilters.length) return '';
  if (active.length === 0) return '';
  return `${active.map((filter) => slugifyForFilename(filter.label)).join('_')}_only`;
};

export const buildChartExportFilename = ({
  title,
  tabLabel,
  exportFilters,
}: {
  title: string;
  tabLabel: string;
  exportFilters?: Array<ChartExportFilter>;
}): string => {
  const segments = [
    slugifyForFilename(title),
    slugifyForFilename(tabLabel),
    buildFilterSegment(exportFilters),
    formatTimestampForFilename(),
  ].filter(Boolean);
  return `${segments.join('_')}.png`;
};
